import React from 'react';
import {
  GoogleMap,
  useLoadScript,
  Marker,
  InfoWindow
} from '@react-google-maps/api';

import './../../App.css';
import '@reach/combobox/styles.css';

import MapStyles from '../../MapStyles';

const libraries = ['places'];
const mapContainerStyle = {
  width: '100vw',
  height: '25vh'
};

const options = {
  styles: MapStyles
  //disableDefaultUI: true,
  //zoomControl: true
};

const Map = props => {
  const coor = props.place.location.coordinates;
  const center = {
    lat: coor[0],
    lng: coor[1]
  };

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    language: 'pt',
    libraries
  });
  //setState on marker click and retrieve value when clicked by user
  const [selected, setSelected] = React.useState(null);

  //use this to reference the map without causing re-renders
  const mapRef = React.useRef();
  const onMapLoad = React.useCallback(map => {
    mapRef.current = map;
  }, []);

  if (loadError) return 'Error loading maps';
  if (!isLoaded) return 'Loading Maps';
  return (
    <section className="map map--single-place">
      <GoogleMap
        mapContainerStyle={mapContainerStyle}
        zoom={15}
        center={center}
        options={options}
        // onClick={onMapClick}
        onLoad={onMapLoad}
      >
        {props.place && (
          <Marker
            position={{ lat: center.lat, lng: center.lng }}
            icon={{
              url: 'http://maps.google.com/mapfiles/ms/icons/pink-dot.png'
            }}
            onClick={() => {
              setSelected(props.place);
            }}
          />
        )}
        {selected ? (
          <InfoWindow
            position={{ lat: center.lat + 0.0005, lng: center.lng }}
            onCloseClick={() => {
              setSelected(null);
            }}
          >
            <div>
              <h2>{selected.name}</h2>
              <p>{selected.formatted_address}</p>
            </div>
          </InfoWindow>
        ) : null}
      </GoogleMap>
    </section>
  );
};

export default Map;
